export default Object.freeze ({

  // RESULTADOS DE CONSULTAS DE AUTORIZACION DE PRODUCTO -----------------------
  // TAutorizacionProducto

    // Autorizado (normal)
    AP_AUTORIZADO: 0,
    // Posibles motivos de rechazo (comunes)
    AP_GRUPO_PRODUCTOS_NO_VALIDO: 1,
    AP_POLITICA_ACCESO_NO_DEFINIDA: 2,
    AP_ACCESO_NO_AUTORIZADO: 3,
    AP_PRODUCTO_EN_LISTA_NEGRA: 4,
    AP_VEHICULO_NO_AUTORIZADO: 5,
    AP_PRODUCTO_NO_VALIDO: 6,
    AP_INSTALACION_NO_VALIDA: 7,
    AP_PRODUCTO_CADUCADO: 8,
    AP_PRESENCIA_INCORRECTA: 9,
    AP_FUERA_PERIODO_VALIDEZ: 10,
    AP_PENDIENTE_PAGO: 11,
    AP_OPERACION_NO_DISPONIBLE_EN_OFFLINE: 12,
    AP_ENTRADA_FUERA_HORARIO: 13,
    AP_MAXIMO_VALES_DESCUENTO_ALCANZADO: 14,
    AP_NUMERO_USOS_DIARIO_AGOTADO: 15,
    AP_NUMERO_USOS_TOTAL_AGOTADO: 16,
    AP_IMPORTE_MINIMO_DESCUENTOS_NO_ALCANZADO: 17,
    AP_COBRO_NO_AUTORIZADO: 18,
    AP_PRODUCTO_PENDIENTE_DE_CANJEAR: 19,
    AP_SALDO_INSUFICIENTE: 20,
    // Posibles motivos de rechazo (locales)
    AP_PRODUCTO_YA_APLICADO_AL_COBRO: 30,
    // Posibles motivos de rechazo (servidor)
    AP_APARATO_NO_VALIDO: 40,
    AP_VERSION_SOPORTE_INCORRECTA: 41,
    AP_PRODUCTO_BLOQUEADO: 42,
    AP_APARCAMIENTO_COMPLETO: 43,
    AP_PRODUCTO_FUERA_DE_CIRCULACION: 44,
    AP_MAXIMO_PRODUCTOS_PRESENTES_ALCANZADO: 45,
    AP_CLIENTE_DADO_DE_BAJA: 46,
    AP_ENTRADA_FUERA_TRAMO_RENOVACION: 47,
    AP_PLAZO_PAGO_RENOVACION_VENCIDO: 48,
    AP_EXPEDICION_DENEGADA_VEHICULO_CLIENTE: 49,
    AP_PRODUCTO_FUERA_DE_CIRCULACION_DESCONOCIDO: 50,
    AP_PRODUCTO_TODAVIA_NO_ES_VALIDO: 51,
    AP_EFECTUAR_ALTA_PRODUCTO: 52,
    AP_EFECTUAR_COBRO_PASARELA_PAGO: 53,
    // OK (Especiales)
    AP_AUTORIZADO_MODO_SOBREOCUPACION: 100,
    AP_AUTORIZADO_MODO_FACTURACION: 101,
    AP_AUTORIZADO_MODO_CREDITO: 102,
    AP_AUTORIZADO_MODO_TARJETA_FIDELIZACION: 103,
    AP_AUTORIZADO_SISTEMA_EXTERNO: 104,
    // ?
    AP_AUTORIZACION_NO_DISPONIBLE: 200,
    AP_MATRICULA_REGISTRADA_PERO_SIN_USO_AUTOMATICO: 201,










  // INCIDENCIAS ---------------------------------------------------------------
  // TIncidenciaSistema

    INC_DESCONOCIDA: 0,

    INC_ACCESO_OPERADOR: 1,
    INC_FIN_SIN_TICKETS: 3,
    INC_FIN_POCOS_TICKETS: 4,
    INC_VIA_HABILITADA: 5,
    INC_FIN_FUERA_SERVICIO: 6,
    INC_CARTEL_COMPLETO_DESACTIVADO: 7,
    INC_CARTEL_COMPLETO_FORZADO_DESACTIVADO: 8,
    INC_RECAUDACION_COFRES: 9,
    INC_IMPRESORA_CON_PAPEL: 10,
    INC_FIN_MODO_PRECIO_EXACTO: 11,
    INC_FIN_FUERA_SERVICIO_SERVIDOR_CAPTURAS_CAMARAS: 12,

    INC_EXCESO_TIEMPO_TKT_PAGADO: 100,
    INC_INICIO_POCOS_TICKETS: 101,
    INC_EXCESO_TIEMPO_TKT_NO_PAGADO: 102,
    INC_PRESENCIA_INCORRECTA: 150,
    INC_ENTRADA_FUERA_HORARIO: 151,
    INC_EXCESO_TIEMPO: 152,
    INC_ERROR_ZONA: 153,
    INC_PLAZAS_ABONADO_COMPLETAS: 154,
    INC_PRODUCTO_CADUCADO: 155,
    INC_ACCESO_DENEGADO: 156,
    INC_TARIFA_NO_VALIDA: 157,
    INC_FUERA_PERIODO_VALIDEZ: 158,
    INC_CARTEL_COMPLETO_ACTIVADO: 159,
    INC_CARTEL_COMPLETO_FORZADO_ACTIVADO: 160,
    INC_IMPRESORA_SIN_PAPEL: 161,
    INC_INICIO_MODO_PRECIO_EXACTO: 162,
    INC_LIMITE_IMPORTE_COBRO_SUPERADO: 163,
    INC_ENTRADA_FUERA_TRAMO_RENOVACION: 164,
    INC_PLAZO_PAGO_RENOVACION_VENCIDO: 165,
    INC_EXPEDICION_DENEGADA_VEHICULO_CLIENTE: 166,
    INC_VEHICULO_SIN_DISPOSITIVO_VIA_VERDE: 167,
    INC_ERROR_SISTEMA_VIA_VERDE: 168,
    INC_MATRICULA_NO_DETECTADA: 169,
    INC_PASO_CON_BARRERA_CERRADA: 170,
    INC_MATRICULA_EN_LISTA_VIGILANCIA: 171,
    INC_PRODUCTO_FUERA_DE_CIRCULACION: 172,
    INC_DESCUENTO_NO_APLICADO: 173,
    INC_USO_AUTOMATICO_PRODUCTO_POR_MATRICULA_DESCARTADO: 174,

    INC_ERROR_LECTOR_TICKETS: 200,
    INC_ERROR_BARRERA: 201,
    INC_INICIO_SIN_TICKETS: 202,
    INC_VIA_DESHABILITADA: 203,
    INC_ERROR_LECTOR_PROXIMIDAD: 204,
    INC_ERROR_IMPRESORA_TERMICA: 205,
    INC_ERROR_ACEPTADOR_MONEDAS: 206,
    INC_ERROR_ACEPTADOR_BILLETES: 207,
    INC_ERROR_MANEJADOR_DINERO: 208,
    INC_ERROR_DISPENSADOR_MONEDAS: 209,
    INC_ERROR_DISPENSADOR_BILLETES: 210,
    INC_ERROR_DISPENSACION_RECICLADOR_BILLETES: 211,
    INC_ERROR_LECTOR_TAGS: 212,
    INC_ERROR_KIT_EMV: 213,
    INC_JUSTIFICANTE_DEVOLUCION_EFECTIVO: 220,
    INC_JUSTIFICANTE_DEVOLUCION_PRODUCTO: 221,
    INC_ACCESO_OPERADOR_DENEGADO: 230,
    INC_PRODUCTO_DADO_DE_BAJA: 250,
    INC_CLIENTE_DADO_DE_BAJA: 251,
    INC_ERROR_SENSOR_PRESENCIA_BARRERA: 260,
    INC_ERROR_LECTOR_CODIGO_BARRAS: 261,
    INC_ERROR_LECTOR_CODIGO_BARRAS_ADICIONAL: 262,
    INC_ERROR_LECTOR_PROXIMIDAD_SECUNDARIO: 263,
    INC_INICIO_FUERA_SERVICIO_SERVIDOR_CAPTURAS_CAMARAS: 270,

    INC_INICIO_FUERA_SERVICIO: 300,
    INC_FALLO_COMUNICACION: 302,
    INC_COFRE_LLENO: 303,
    INC_PRODUCTO_NO_VALIDO: 350,

    INC_APERTURA_MANUAL_BARRERA: 401,
    INC_CIERRE_MANUAL_BARRERA: 402,
    INC_BLOQUEO_BARRERA: 403,
    INC_DESBLOQUEO_BARRERA: 404,
    INC_MODO_SALIDAS_NORMAL: 405,
    INC_EXPEDICION_TICKET_MANUAL: 406,
    INC_REAJUSTE_OCUPACION_ZONA: 407,
    INC_MODO_SALIDAS_CONGESTION_TP: 408,
    INC_MODO_SALIDAS_CONGESTION_TT: 409,
    INC_RELE_AUXILIAR_ACTIVADO: 410,
    INC_RELE_AUXILIAR_DESACTIVADO: 411,
    INC_IDENTIFICACION_MATRICULA_MANUAL: 412,
    INC_AJUSTE_CARGA_TICKETS: 413,
    INC_APAGAR_SISTEMA: 414,
    INC_ARQUEO_TURNO: 415,
    INC_CIERRE_TURNO: 416,
    INC_RESTITUCION_PRODUCTO: 417,
    INC_COBRO_CANCELADO: 418,
    INC_MODO_SALIDAS_APERTURA_BARRERA_AUTOMATICA: 419,

    INC_PRODUCTO_BLOQUEADO: 750,
    INC_MOVIMIENTO_ENTRADA_SALIDA_INCOMPLETO: 751,
    INC_PRODUCTO_EN_LISTA_NEGRA: 752,

    INC_REINICIO_LECTOR_TICKETS: 800,
    INC_REINICIO_LECTOR_CODIGO_BARRAS: 801,
    INC_REINICIO_LECTOR_PROXIMIDAD: 802,
    INC_TEST_MONEDERO: 803,
    INC_TEST_BILLETERO: 804,
    INC_TEST_DISPENSADORES: 805,
    INC_TEST_IMPRESORA_RECIBOS: 806,

    INC_SISTEMA_INICIADO: 900,
    INC_PUERTA_CERRADA: 901,
    INC_CAJA_FUERTE_CERRADA: 902,
    INC_AJUSTE_CONTADORES: 903,
    INC_RECARGA_AUTOMATIZADA: 904,
    INC_VACIADO_DISPENSADORES: 905,
    INC_APARATO_EN_COMUNICACION: 906,
    INC_ALARMA_SUSPENDIDA: 907,

    INC_REINICIO_SISTEMA: 1000,
    INC_PUERTA_ABIERTA: 1001,
    INC_CAJA_FUERTE_ABIERTA: 1002,
    INC_EXTRACCION_COFRE_MONEDAS: 1003,
    INC_EXTRACCION_COFRE_BILLETES: 1004,
    INC_ALARMA_ACTIVADA: 1005,

    INC_SISTEMA_FINALIZADO: 1100,
    INC_APARATO_SIN_COMUNICACION: 1101,










  // MOTIVOS DE APERTURAS MANUALES DE BARRERA ----------------------------------
  // TMotivoAperturaManual

    MAM_DESCONOCIDO: 0,
    MAM_ERROR_HORARIO: 1,
    MAM_ERROR_PRESENCIA: 2,
    MAM_EXCESO_TIEMPO: 3,
    MAM_MAXIMO_PLAZAS_ALCANZADO: 4,
    MAM_OTRO: 5,
    MAM_PERDIDA_PRODUCTO: 6,
    MAM_PRODUCTO_CADUCADO: 7,
    MAM_PRODUCTO_ILEGIBLE: 8,
    MAM_PRODUCTO_OLVIDADO: 9,
    MAM_VEHICULO_NO_AUTORIZADO: 10,

});
